import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './formSubtitle.module.scss'

const FormSubtitle = (props) => {
  const { content, position, expand, ...rest } = props
  return (
    <div
      className={classNames(styles.subtitle, styles[position])}
      style={{ flexGrow: expand || 'inherit' }}
      {...rest}
    >
      <span>{content}</span>
    </div>
  )
}

FormSubtitle.propTypes = {
  content: PropTypes.string.isRequired
}

export default FormSubtitle
